export default "__VITE_ASSET__B$$1nPpy__"